import * as React from 'react'
import { withRouter, RouteComponentProps } from 'react-router'

import { LayoutContainer } from './LayoutStyles'
import FeatureRouter from './Features/FeatureRouter'

import FeedbackForm from '../FeedbackForm'
import LoginForm from '../LoginForm'

import LayoutHeader from './LayoutHeader'
import LayoutFooter from './LayoutFooter'
import MainRoutes from './MainRoutes'

type LayoutProps = {
  feedbackOpen: boolean
  openFeedback: () => void
  closeFeedback: () => void
} & RouteComponentProps<{}>

const Layout: React.SFC<LayoutProps> = props => (
  <LayoutContainer
    home={
      props.location.pathname === '/' || props.location.pathname === '/login'
    }
  >
    {/* We keep the feedback form always mounted, it manages its own visibility */}
    <FeedbackForm
      open={props.feedbackOpen}
      closeFeedback={props.closeFeedback}
    />
    {/* Ditto for the login form. When we move to R16, we can use portals for these. */}
    <LoginForm forceLogin={props.location.pathname === '/login'} />
    <LayoutHeader pathname={props.location.pathname} />
    <MainRoutes />
    <FeatureRouter openFeedback={props.openFeedback} />
    <LayoutFooter />
  </LayoutContainer>
)

export default withRouter(Layout)



// WEBPACK FOOTER //
// ./src/Components/Layout/index.tsx